module.exports = __webpack_public_path__ + "img/drug-10.92218342.png";